import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCpdCianSource, setCpdSource, setPrelandingModalOpen } from 'shared/actions/cpd';
import { CPDAsideTrap } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { selectIsCpdTrapTextExperiment } from 'shared/selectors/abExperiments/selectIsCpdTrapTextExperiment';
import { ECpdPrelandingModalView } from 'shared/types/cpd/cpd';

export const CPDAsideTrapContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { trackCPDTrapVisible, trackCPDTrapClick } = useCpdTracking();

  const isCpdTrapTextExperimentGroupB = useSelector(selectIsCpdTrapTextExperiment);

  const { config } = useApplicationContext();
  const prelandingContent = isCpdTrapTextExperimentGroupB
    ? config.get<ICPDPrelandingConfig>('CPDPrelandingDataV2')
    : config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  const onTrapClick = React.useCallback(() => {
    dispatch(setPrelandingModalOpen({ isOpen: true, modalView: ECpdPrelandingModalView.Searcher }));
    dispatch(setCpdSource('trapOfferScreenPriceBlock'));
    dispatch(setCpdCianSource('trapOfferScreenPriceBlock_web'));
    trackCPDTrapClick('trapOfferScreenPriceBlock');
  }, []);

  if (!prelandingContent?.searcher) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={() => trackCPDTrapVisible('trapOfferScreenPriceBlock')} callbackDelay={1000}>
      <CPDAsideTrap
        title={isCpdTrapTextExperimentGroupB ? 'Подобрать агента' : 'Эксперт от Циана'}
        description={
          isCpdTrapTextExperimentGroupB
            ? 'Безопасная покупка и продажа вместе с профи от Циана'
            : 'Помощь с поиском и гарантия безопасной сделки'
        }
        onClick={onTrapClick}
      />
    </ActionAfterViewObserver>
  );
};
